import { shiftEditorViewState } from "..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateNotesTimeoff", function updateNotesTimeoff(notes: string) {
    if (shiftEditorViewState().timeoff) {
        shiftEditorViewState().timeoff.notes = notes;
    }
});